import { KitDemoPage } from "@/layouts/portal/KitDemoPage";
import { PORTAL_PATH } from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

const PRODUCTION_MODE = "production";

export const Route = createFileRoute("/vendor/kit")({
	validateSearch: (search: Record<string, unknown>): { kunci?: boolean } => ({
		kunci: search.kunci ? true : undefined,
	}),
	beforeLoad: () => {
		if (import.meta.env.MODE === PRODUCTION_MODE) {
			throw redirect({ to: PORTAL_PATH.Home });
		}
	},
	component: KitRoute,
});

function KitRoute() {
	const { kunci } = Route.useSearch();
	return <KitDemoPage isLockDemo={Boolean(kunci)} />;
}
